import { useTranslations } from "next-intl";

const baseDateRegex = /(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})/;
const invertedDateRegex = /(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})/;
export const getQuarter = (date: Date | string): string => {
  // const t = useTranslations();
  let conversionDate;
  let year;
  if (date instanceof Date) {
    conversionDate = date;
    year = conversionDate.getFullYear();
  } else {
    const baseRe = new RegExp(baseDateRegex);
    const invertedRe = new RegExp(invertedDateRegex);
    if (baseRe.test(date)) {
      const dateParts = date.match(baseDateRegex);
      if (dateParts && dateParts[1] && dateParts[3] && dateParts[5]) {
        year = Number(dateParts[5]);
        conversionDate = new Date(year, Number(dateParts[3]) - 1, Number(dateParts[1]));
      } else {
        return "";
      }
    } else if (invertedRe.test(date)) {
      const dateParts = date.match(invertedRe);
      if (dateParts && dateParts[1] && dateParts[3] && dateParts[5]) {
        year = Number(dateParts[1]);
        conversionDate = new Date(year, Number(dateParts[3]) - 1, Number(dateParts[5]));
      } else {
        return "";
      }
    } else {
      console.error("incorrect date", date);
      return "";
    }
  }
  if (conversionDate > new Date()) {
    return `Q${Math.floor((conversionDate.getMonth() + 3) / 3)} / ${year}`;
  } else {
    return "ready";
  }
};
export function formatDate(dateStr: Date | string, lang: string = "en") {
  // Cast string input to Date if it's a string
  const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
  return new Intl.DateTimeFormat(lang, {
    day: "numeric",
    month: "short",
    year: "numeric",
    /*  hour: "2-digit",
    minute: "2-digit", */
  }).format(new Date(dateStr));
}

export function getFulDateYear(dateStr: Date | string, lang: string = "en") {
  // Cast string input to Date if it's a string
  const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
  return date.getFullYear();
}
